import {
  appLayoutGuard,
  authLayoutGuard,
  customerFeaturesGuard
} from '@dxc/data-access';
import { DxRoute } from '@shared/types';

export const appRoutes: DxRoute[] = [
  {
    path: '',
    loadComponent: () =>
      import('@shared/layouts').then((m) => m.AppLayoutComponent),
    canActivateChild: [appLayoutGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('@dxc/home').then((_) => _.homeRoutes)
      },
      {
        path: 'cases',
        loadChildren: () => import('@dxc/cases').then((_) => _.casesRoutes)
      },
      {
        path: 'customer-cases',
        loadChildren: () =>
          import('@dxc/customer-cases').then((_) => _.customerCasesRoutes),
        data: { feature: 'moduleCasesCustomer' },
        canActivate: [customerFeaturesGuard]
      },
      {
        path: 'elliptic-cases',
        loadChildren: () =>
          import('@dxc/elliptic-cases').then((_) => _.ellipticCasesRoutes),
        data: { feature: 'moduleCasesElliptic' },
        canActivate: [customerFeaturesGuard]
      },
      {
        path: 'transaction-cases',
        loadChildren: () =>
          import('@dxc/transaction-cases').then(
            (_) => _.transactionCasesRoutes
          ),
        data: { feature: 'moduleCasesTransaction' },
        canActivate: [customerFeaturesGuard]
      },
      {
        path: 'travel-rule-cases',
        loadChildren: () =>
          import('@dxc/travel-rule-cases').then((_) => _.travelRuleCasesRoutes),
        data: { feature: 'moduleCasesTravelRule' },
        canActivate: [customerFeaturesGuard]
      },
      {
        path: 'rules',
        loadChildren: () => import('@dxc/rules').then((_) => _.rulesRoutes),
        data: { feature: 'moduleRuleEngine' },
        canActivate: [customerFeaturesGuard]
      },
      {
        path: 'moduleDxTective',
        loadChildren: () =>
          import('@dxc/dxtective').then((_) => _.dxtectiveRoutes),
        data: { feature: 'moduleDxTective' },
        canActivate: [customerFeaturesGuard]
      },
      {
        path: 'customers',
        loadChildren: () =>
          import('@dxc/customers').then((_) => _.customersRoutes),
        data: { feature: 'moduleCustomers' },
        canActivate: [customerFeaturesGuard]
      },
      {
        path: 'funds',
        loadChildren: () => import('@dxc/funds').then((_) => _.fundsRoutes),
        data: { feature: 'moduleFunds' },
        canActivate: [customerFeaturesGuard]
      },
      {
        path: 'sar',
        loadChildren: () => import('@dxc/sar').then((_) => _.sarRoutes),
        data: { feature: 'moduleSar' },
        canActivate: [customerFeaturesGuard]
      },
      {
        path: 'charts',
        loadChildren: () => import('@dxc/charts').then((_) => _.chartsRoutes),
        data: { feature: 'moduleCharts' },
        canActivate: [customerFeaturesGuard]
      },
      {
        path: 'leadership',
        loadChildren: () =>
          import('@dxc/leadership').then((_) => _.leadershipRoutes),
        data: { feature: 'moduleLeadership' },
        canActivate: [customerFeaturesGuard]
      },
      {
        path: 'users',
        loadChildren: () => import('@dxc/users').then((_) => _.usersRoutes),
        data: { feature: 'moduleUsers' },
        canActivate: [customerFeaturesGuard]
      },
      {
        path: 'audit-trail',
        loadChildren: () =>
          import('@dxc/audit-trail').then((_) => _.auditTrailRoutes),
        data: { feature: 'moduleAuditTrail' },
        canActivate: [customerFeaturesGuard]
      },
      {
        path: 'upload-data',
        loadChildren: () =>
          import('@dxc/upload-data').then((_) => _.uploadDataRoutes),
        data: { feature: 'moduleUploadData' },
        canActivate: [customerFeaturesGuard]
      },
      {
        path: 'my-account',
        loadChildren: () =>
          import('@dxc/account-settings').then((_) => _.accountSettingsRoutes),
        data: { feature: 'moduleMyAccount' },
        canActivate: [customerFeaturesGuard]
      },
      {
        path: 'app-settings',
        loadChildren: () =>
          import('@dxc/app-settings').then((_) => _.appSettingsRoutes),
        data: { feature: 'moduleAppSettings' },
        canActivate: [customerFeaturesGuard]
      },
      {
        path: 'abrdn-settings',
        loadChildren: () =>
          import('@dxc/abrdn-settings').then((_) => _.abrdnSettingsRoutes),
        data: { feature: 'moduleAbrdnSettings' },
        canActivate: [customerFeaturesGuard]
      }
    ]
  },
  {
    path: '',
    loadChildren: () =>
      import('@shared/layouts').then((m) => m.authLayoutRoutes),
    canActivateChild: [authLayoutGuard],
    data: { app: 'dxc' }
  }
];
